
export interface IThemeColour {
    colour: string
    setColour: (colour: string) => void
}

export enum ThemeColours {
    Red = "E63946",
    Coral = "FF595E",
    Orange = "F77F00",
    Yellow = "FCBF49",
    Teal = "2A9D8F",
    Ice = "A8DADC",
    Navy = "1D3557",
    DarkTeal = "264653",
    Blue = "457B9D",
    BrightBlue = "1982C4",
    Purple = "6A4C93",
    Lilac = "C77DFF",
    Lime = "8AC926",
    Crimson = "D62828",
    DeepBlue = "023E8A"
}

export const topRow : ThemeColours[] = [
    ThemeColours.Red,
    ThemeColours.Coral,
    ThemeColours.Orange,
    ThemeColours.Yellow,
    ThemeColours.Teal,
    ThemeColours.Ice,
    ThemeColours.Navy,
    ThemeColours.DarkTeal
];

export const bottomRow : ThemeColours[] = [
    ThemeColours.Blue,
    ThemeColours.BrightBlue,
    ThemeColours.Purple,
    ThemeColours.Lilac,
    ThemeColours.Lime,
    ThemeColours.Crimson,
    ThemeColours.DeepBlue
];
